import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import InstructorHeader from '../InstructorHeader/InstructorHeader';
import MLRadioButtonGroup from '../../../MLRadio/MLRadioButtonGroup';
import MLRadioButton from '../../../MLRadio/MLRadioButton';
import MLButton from '../../../MLButton';
import EmptyCourseList from '../EmptyCourseList/EmptyCourseList';

import s from './LinkCourses.module.css';

const getCourseListItems = (courseList) => {
  return map(courseList, (course, idx) => {
    const id = course.id;
    const sanitizedName = course.name.toLowerCase().split(' ').join('_');
    const testId = `radio_button_${sanitizedName}`;
    const courseYear = new Date(course.startDate).getFullYear();

    return (
      <MLRadioButton
        key={idx}
        className={s.listCourseBtn}
        value={id}
        text={course.name}
        textClass={s.courseName}
        testId={testId}
      >
        <span className={s.courseTerm}>{course.term}</span>
        <span className={s.courseYear}>{courseYear}</span>
      </MLRadioButton>
    );
  });
};

const LinkCourses = ({
  courseList,
  selectedCourse,
  handleCreateCourse,
  handleChangeButtonGroup,
  handleCourseAssociation,
  handleGetReefCourseList,
}) => {
  if (!Array.isArray(courseList)) return null;

  return (
    <div className={s.reefLinkBody} data-test-id="reef-link-course">
      <InstructorHeader
        handleCreateCourse={handleCreateCourse}
        handleGetReefCourseList={handleGetReefCourseList}
      />

      {isEmpty(courseList) && (
        <EmptyCourseList
          onClickCreateCourse={handleCreateCourse}
          onClickRefreshList={handleGetReefCourseList}
        />
      )}

      <MLRadioButtonGroup
        className={s.courseList}
        onChange={handleChangeButtonGroup}
      >
        {getCourseListItems(courseList)}
      </MLRadioButtonGroup>

      <div className={s.linkBtnContainer}>
        <MLButton
          className={s.linkBtn}
          btnType="primary"
          disabled={!selectedCourse}
          testId="save-and-link-courses"
          onClick={handleCourseAssociation}
        >
          Save and Link Courses
        </MLButton>
      </div>
    </div>
  );
};

LinkCourses.propTypes = {
  courseList: PropTypes.array,
  selectedCourse: PropTypes.string,
  handleCreateCourse: PropTypes.func,
  handleChangeButtonGroup: PropTypes.func,
  handleCourseAssociation: PropTypes.func,
  handleGetReefCourseList: PropTypes.func,
};

export default LinkCourses;
